import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Clients } from "@src/api/v1/Clients";
import { OpenUpHttpClient } from "@src/api/OpenUpHttpClient";

const identifier = "external-questionnaires";

export const useQuestionnairesQuery = (clientId: string) =>
  useQuery({
    queryKey: ["clients", clientId, identifier],

    queryFn: () =>
      new Clients(OpenUpHttpClient).getExternalQuestionnaires(clientId),
  });

export const useQuestionnaireMutation = (clientId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      new Clients(OpenUpHttpClient).createExternalQuestionnaires(clientId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["clients", clientId, identifier],
      });
    },
  });
};
